module.exports = __webpack_public_path__ + "img/p6.c14d7bea.png";